/**
 * Copyright 2024 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */
export function assertUnreachable(x: never): never {
  throw new Error(`Unexpected value [${x}]. This should never be reached`);
}

export default assertUnreachable;